export default window.M;
